import { default as module } from './AbstractModule';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);

        this.active = false
    }

    init() {

    }

    toggle() {
        if(!this.active) this.open()
        else this.close()
    }

    open() {
        this.active = true
        this.update()
    }

    close() {
        this.active = false
        this.update()
    }

    update() {
        if(this.active)
            html.classList.add('has-menu-opened')
        else
            html.classList.remove('has-menu-opened')

        this.call('setActive', this.active, 'Navdot', 'nav')
        window.app.menuOpen = this.active
    }
}
